export default [
  {
    component: () => import('./Me.vue'),
    children: [
      {
        name: 'MeEditData',
        path: '/me/edit',
        component: () => import('./content/MeEditData.vue'),
        meta: {
          title: 'Meus Dados',
        },
      },
    ],
  },
];
